<template>
  <div id="lang">
    <p style="display: none">
      <a style="color:white" href="javascript:void(0)" @click="setLang('ja')" class=" typo-l6">
        {{ $t('common.japanese')}}
      </a>
      <a style="color:white" href="javascript:void(0)" @click="setLang('en')" class=" typo-l6">
        {{ $t('common.english') }}
      </a>
    </p>
    <p>
      <b-form-select id="basicSelect" v-model="current_lang" v-bind:value="current_lang"
                     size="sm"
                     :plain="true"
                     :options="options"
                     >
      </b-form-select>
    </p>
  </div>
</template>
<style>
  #basicSelect {
    height: 33px;
  }
</style>
<script>
import Vue from 'vue'
let vm = null
export default {
  name: 'lang',
  data: function () {
    return {
      current_lang: 'en',
      options: []
    }
  },
  methods: {
    setLang (lang) {
      this.$store.dispatch('setLang', lang)
      let langArray = lang ? lang.split('_') : []
      this.$session.set('lang', langArray[0])
      Vue.axios.defaults.headers.common['Lang'] = langArray[0]
      this.$store.commit('setLang', lang)
      this.$root.$emit('changeLang')
    },
    async init () {
      let config = this.$store.getters.config
      this.current_lang = this.$session.get('lang') || 'en'
      this.options = []
      if (config != null && config.main != null && config.main.language != null) {
        await this.getLanguageList(config);
        await this.updateCurrentLanguageWithEnglish(config);
      }
    },
    async getLanguageList(config) {
      for (let i in config.main.language) {
          this.options[config.main.language[i]] = []
          this.options.push({
            text: vm.$t('common.'+config.main.language[i]),
            value: config.main.language[i] == 'en' ? config.main.language[i] + '_' + config.base.id : config.main.language[i]
          })
        }
    },
    async updateCurrentLanguageWithEnglish(config) {
      if (this.current_lang == 'en' && config.main.main_language != null && config.main.main_language != '') {
          if (config.main.main_language == 'en') {
            this.current_lang = 'en_' + config.base.id
          } else {
            if (this.current_lang == 'en') {
              this.current_lang = 'en_' + config.base.id
            } else {
              if (this.$session.get('lang') == null) {
                this.current_lang = config.main.main_language
              }
            }
          }
        }
    }
  },
  created () {
    vm = this
  },
  mounted () {
    this.$root.$on('UpdatedConfig', () => {
      this.init()
    })
    this.init()
  },
  watch: {
    current_lang: function (val) {
      this.setLang(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partials/ChangeLanguages.vue